import React from "react";
import { RegisterForm } from "../components/Forms";
import "./../styles/pages.scss";
const Register = () => {
  return (
    <section className="section">
      <RegisterForm />
    </section>
  );
};

export default Register;
